export default {
  SET_USER (state, payload) {
    state.user = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js